const initialAssignmentsFilterState = {
  fetching: false,
  fetched: false,
  items: [],
  filteredItems: [],
  error: null,
  sum : 0,
  nbResult: 0,
};

export const getDoublePaymentReducer = (state = initialAssignmentsFilterState, action) => {
  switch (action.type) {
    case "GET_DOUBLE_PAYMENT_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "GET_DOUBLE_PAYMENT_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data.data : [],
        filteredItems: data ? data.data : [],
        sum : data ? data.somme : 0,
        nbResult: nbResult
      };
    }

    case "GET_DOUBLE_PAYMENT_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        filteredItems: [],
        nbResult: 0,
        sum: 0,
        error
      };
    }


    case "SET_FILTERED_DOUBLE_PAYMENT_ITEMS" : {
      return {...state, filteredItems: action.payload};
    }

    case "REMOVE_DOUBLE_PAYMENT" : {
      var filtered = state.filteredItems.filter(function(item, index, arr){
        return item.id != action.payload;
      });
      return {...state, filteredItems: filtered};
    }

    case "CHANGE_REFUNDED_ORDERS_STATUS" : {
      let items = state.filteredItems.map(function(item) {
        if(action.payload.includes(item.id + "")){
          item.refundByBankTransferStatus = "PENDING";
        }
        return item;
      });
      return {...state, filteredItems: items};
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/statistics/getDoublePayment.js